export default () => ({
	loading: false,
	fetchLoading: false,
	materialsAndSupplies: [],
});
